import React from 'react';
import { MaxWidth } from '../../../../base';

export default function Desktop({ children, className = undefined }) {
  return (
    <div
      className={className}
      css={MaxWidth.sm`
        display: none;`}
    >
      {children}
    </div>
  );
}
